import { cn } from '@/lib/utils';

interface ActivityChipProps {
  /** PT calendar days since last activity (milestone change or conversation log). */
  days: number | null;
  className?: string;
}

/**
 * Muted "parked but alive" chip for loans that have conversation-log activity
 * and no risk flag. Display-only — never feeds segments, counts, or sorts.
 * Geometry matches RiskFlag so the Flag column stays visually aligned; the
 * hollow dot (vs RiskFlag's filled dot) marks it as informational.
 */
export function ActivityChip({ days, className }: ActivityChipProps) {
  const label = days === null ? 'Active' : `Active · ${days}d`;
  return (
    <span
      className={cn(
        'inline-flex items-center gap-1 rounded-sm px-1.5 py-0.5 text-[10px] font-medium whitespace-nowrap',
        'bg-muted/60 text-muted-foreground',
        className
      )}
    >
      <span aria-hidden className="inline-block h-1 w-1 rounded-full border border-current" />
      {label}
    </span>
  );
}
